import { track } from './amplitude';
import { PHOTO_VIEWER_OPENED, PHOTO_VIEWER_CLOSED } from './events';
import { currentSceneId } from './trackerContext';
import {
  assistantViewerOpened,
  assistantViewerClosed,
  assistantViewerIndexChanged,
  type AssistantViewerSource,
} from '../state/assistantHud';

/**
 * Engagement-метрики PhotoViewer. Считаем только активное открытие
 * fullscreen-просмотрщика (не passive impressions inline). Пара
 * Opened/Closed закрывает воронку: % сессий с открытием фото, среднее
 * dwell time, доля swipe-просмотра (`slides_viewed`).
 *
 * Состояние в module-local переменных — на любое время открыт максимум
 * ОДИН viewer (overlay singleton в `AssistantHud`).
 */

type ViewerSession = {
  openedAt: number;
  sceneId: string | null;
  source: AssistantViewerSource;
  photosInSet: number;
  initialIndex: number;
  visitedIndexes: Set<number>;
};

let session: ViewerSession | null = null;

export const startPhotoTracking = (): void => {
  assistantViewerOpened.watch(({ items, index, source }) => {
    const initialIndex = index ?? 0;
    const resolvedSource: AssistantViewerSource = source ?? 'inline-message';
    session = {
      openedAt: performance.now(),
      sceneId: currentSceneId(),
      source: resolvedSource,
      photosInSet: items.length,
      initialIndex,
      visitedIndexes: new Set<number>([initialIndex]),
    };
    track(PHOTO_VIEWER_OPENED, {
      scene_id: session.sceneId,
      source: resolvedSource,
      photos_in_set: items.length,
      initial_index: initialIndex,
    });
  });

  assistantViewerIndexChanged.watch((index) => {
    if (session === null) return;
    session.visitedIndexes.add(index);
  });

  assistantViewerClosed.watch(() => {
    if (session === null) return;
    const durationMs = Math.round(performance.now() - session.openedAt);
    track(PHOTO_VIEWER_CLOSED, {
      scene_id: session.sceneId,
      source: session.source,
      photos_in_set: session.photosInSet,
      duration_ms: durationMs,
      slides_viewed: session.visitedIndexes.size,
    });
    session = null;
  });
};
